/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CategoryBasicView } from './categoryBasicView';
import { MedStaffData } from './medStaffData';
import { OrganizationLink } from './organizationLink';

export interface MedStaff extends MedStaffData { 
    treatment_of_diseases?: Array<CategoryBasicView>;
    specialty?: Array<CategoryBasicView>;
}